global.CN_EN = {
    'operateSuccess': ['操作成功', 'Operate successfully'],
    'operateFail': ['操作失败', 'Operate failure'],

    //联系我们
    'contactUs': ['软件开发解决方案请联系', 'Contact Info'],
    'none':['无','None'],
    'searchProject':['搜索项目','Search project name'],
    'notNoticeForHead':['（已归档）', '(Archived)'],

    //登录、注册
    'login': ['登录', 'Login'],
    'joiningProjectTip': ['您正在加入项目，请稍后...', 'You are joining the project, please wait patiently...'],
    'googlelogin': ['登录', 'sign in'],
    'faceBooklogin': ['登录', 'sign in'],
    'register': ['注册', 'Sign up'],
    'explain':['沟通无碍，协作无界','Communicate without hindrance, collaboration without limit'],
    'explain1':['轻量、快捷的项目管理平台','Lightweight, fast project management platform'],
    'explain2':['快速定位每一个任务','Locate each task quickly'],
    'explain3':['提高团队工作效率与质量','Improve team work efficiency and quality'],
    'explain4':['合作更加简洁、高效','Collaboration is more concise and efficient'],
    'enterEmailAddress':['请输入邮箱地址','Please input your email address'],
    'enterPwd':['请设置登录密码','Please set login password'],
    'enterEmailCode':['请输入邮箱验证码','Please input the email code'],
    'rememberMe':['记住我','Remember Me'],
    'forgotPwd':['忘记密码','Forgot Password'],
    'getCode':['获取验证码','Send a code'],
    'countdown':['倒计时','Countdown'],
    'second':['秒','second'],
    'setPwd':['请设置登录密码','Please set login password'],
    'enterRegisterEmail':['请输入注册的邮箱地址','Please input your email address'],
    'enterRegisterAccount':['请输入用户名','Please input your account name'],
    'ok':['确定','Confirm'],
    'inviteRegister':['邀请注册','Invite to register'],
    'passwordLogin': ['密码登录', 'Password login'],
    'forgotPwd_ask':['忘记密码？','Forgot Password?'],
    'copyright':['苏州智奇胜软件科技有限公司',
		'Suzhou ChisalSoft Technology Co., Ltd.'],
    'companyRecord':['苏ICP备 13060847号-3','苏ICP备 13060847号-3'],//备案信息不要翻译
    'noAccount':['还没有账号？','Do not have an account yet ?'],
    'account':['已有账号？','Already have an account ?'],
    'confirm':['注册即代表您已阅读并同意我们的','By signing up you confirm that you have read and agree to our'],
    'service':['服务条款','Terms of Service'],
    'policy':['隐私政策','Privacy Policy'],
    //页面顶部
    'relatedToMe':['与我相关','Related To Me'],
    'basicInfo':['基本资料','Basic Info'],
    'accountSet':['账号设置','Settings'],
    'packageSet':['我的套餐','Package'],
    'exit':['退出','Exit'],
    'createProject':['创建新项目','Create New Project'],
    'projects':['全部项目', 'All Projects'],

    //项目管理
    'allProject':['所有项目','All Projects'],
    'ongoingProject':['进行中项目','Ongoing Projects'],
    'pastProject':['历史项目','Past Projects'],
    'sort':['排序','Sort'],
    'projectName':['项目名称','Project name'],
    'projectListSort1':['项目名称 A-Z','Project name (A-Z)'],
    'projectListSort2':['项目名称 Z-A','Project name (Z-A)'],
    'projectListSort3':['创建时间 由早到晚','Create time (early to late)'],
    'projectListSort4':['创建时间 由晚到早','Create time (late to early)'],
    'projectDetail':['项目详情','Project details'],
    'statistic':['统计','Statistic'],
    'amount':['总数','Amount'],
    'wait':['等待','Pending'],
    'ongoing':['进行中','Ongoing'],
    'done':['已完成','Done'],
    'taskCounts':['任务','Task'],
    'bugCounts':['Bug','Bug'],
    'uploadProjectPicture':['请上传项目图片','Upload a project cover'],
    'pictureSize':['请上传项目封面，建议尺寸为335*140的图片','Please upload a project cover, the recommended size is 335*140'],

    //绑定手机
    'bindPhoneInfo':['为了您的账号安全，请绑定手机',
		'To ensure the security of your account, please bind your mobile phone'],
    'phoneNumber':['手机号','Phone No.'],
    'enterPhone':['请输入手机号','Input your Phone No.'],
    'code':['验证码','Code'],
    'enterCode':['请输入验证码',
		'Please input the code'],
    'sendCode':['发送验证码','Send a code'],
    'cancel':['取消','Cancel'],
    'countryCode':['国际区号','Country Code'],

    //统计
    'dataOverview':['数据概览','Data overview'],
    'taskSummary':['任务汇总','Task summary'],
    'taskTotalCounts':['任务总数','Task count'],
    'today':['今日','Today'],
    'notStartedTasks':['未开始任务','Not started tasks'],
    'inProgressTasks':['进行中任务','In progress tasks'],
    'completedTasks':['已完成任务','completed tasks'],
    'overdueTasks':['已逾期任务','Overdue tasks'],
    'allTasks':['全部任务','All tasks'],
    'notStarted':['未开始','Not started'],
    'Delay':['已逾期','Delay'],
    'recent30':['近30天','In 30 days'],
    'recent15':['近15天','In 15 days'],
    'recent7':['近7天','In 7 days'],
    'bugSummary':['Bug汇总','Bug summary'],
    'bugTotalCounts':['Bug总数','Bug count'],
    'waitFixedBug':['待修复Bug','To be fixed bugs'],
    'fixingBug':['修复中Bug','Fixing bugs'],
    'fixedBug':['已修复Bug','Fixed bug'],
    'allBugs':['全部Bug','All bugs'],
    'waitFixed':['待修复','To be fixed'],
    'fixing':['修复中','Fixing'],
    'fixed':['已修复','Fixed'],
    'bugCountStatistics':['各等级下Bug数量统计','All bug counts at each level summary'],
    'level1Label':['一级：','Level 1: '],
    'level1':['一级','Level 1'],
    'level1Intro':['功能缺失系统崩溃','Function loss/crash'],
    'level2Label':['二级：','Level 2: '],
    'level2':['二级','Level 2'],
    'level2Intro':['功能失效','Function unworkable'],
    'level3Label':['三级：','Level 3: '],
    'level3':['三级','Level 3'],
    'level3Intro':['功能不完善','Function not finished'],
    'level4Label':['四级：','Level 4: '],
    'level4':['四级','Level 4'],
    'level4Intro':['样式优化改进','Promotable'],
    'level5Label':['五级：','Level 5: '],
    'level5':['五级','Level 5'],
    'level5Intro':['新增变更','New demand/changed'],
    'level':['等级','Level'],
    'counts':['数量','Amounts'],
    'percentage':['占比','Percentage'],

    //任务
    'taskList':['任务列表','Task list'],
    'enterIdTitle':['请输入任务ID/标题','Please input taskID/title'],
    'expectedStartTime':['期望开始时间','Expected start'],
    'expectedEndTime':['期望结束时间','Expected end'],
    'actualStartTime':['实际开始时间','Actual start'],
    'actualEndTime':['实际结束时间','Actual end'],
    'startDate':['开始日期','Start date'],
    'endDate':['结束日期','Finished date'],
    'chooseOwner':['请选择负责人','Choose owner'],
    'search':['搜索','Search'],
    'createTask':['新建任务','Create a new task'],
    'batchStartTask':['批量开始任务','Batch start task'],
    'batchFinishTask':['批量完成任务','Batch finish task'],
    'batchStartTaskDialogInfo':['您确定批量开始任务？','Confirm to batch start all selected tasks?'],
    'batchFinishTaskDialogInfo':['您确定批量完成任务？','Confirm to batch finish all selected tasks?'],
    'import':['从Excel导入','Import from Excel'],
    'export':['导出Excel','Export to Excel'],
    'exportTemplate':['下载模板','Download the template'],
    'delete':['删除','Delete'],
    'title':['标题','Title'],
    'expectedTime':['期望时间','Expected time'],
    'actualTime':['实际时间','Actual time'],
    'owner':['负责人','Owner'],
    'operate':['操作','Operate'],
    'noData':['暂无数据','No data'],
    'start':['开始','Start'],
    'deadline':['截止','Deadline'],
    'end':['结束','Finished'],
    'finish':['完成','Done'],
    'edit':['编辑','Edit'],
    'total':['共','Total'],
    'item':['条','Item'],
    'goTo':['前往','Go to page'],
    'page':['页','Page'],
    'taskDescription':['任务描述','Task description'],
    'taskTitle':['任务标题','Task title'],
    'enterTaskTitle':['请输入任务标题','Please input task title'],
    'taskDetailDescription':['详细描述','Description'],
    'enterTaskDetail':['请详细填写任务描述','Please describe the task in detail'],
    'workload':['工作量','Workload'],
    'day':['天','Day'],
    'enterWorkload':['请填写工作量','Please input the workload'],
    'addTaskInfo':['模块/期望时间/负责人','Module/Expected time/Owner'],
    'moduleUnder':['所属模块','Module'],
    'chooseLevel1':['请选择一级模块','Choose level 1 module'],
    'chooseLevel2':['请选择二级模块','Choose level 2 module'],
    'expectedFinishedTime':['期望完成时间','Expected finished time'],
    'multipleChooseOwner':['请选择负责人（可多选）','Please choose owner (Multiple)'],
    'submitTask':['提交任务','Submit task'],
    'uploadInfo':['允许上传jpg/png、doc/docx/xls/xlsx/ppt/pptx、pdf、mp3/wav、mp4大小不超过100MB',
		'Allowed to upload JPG/PNG, doc/docx/xls/xlsx/ppt/pptx, pdf,  mp3, wav, mp4 and each file must be less than 100MB'],
    'uploadTip':['将附件拖到此处，或点击上传', 'Drag to here, or click upload'],
    'expectedDeadlineTime':['期望截止时间','Expected deadline time'],
    'attachment':['附件','Attachment'],
    'downloadAll':['下载全部','Download all files'],
    'deleteMission':['删除任务','Delete task'],
    'confirmDeleteMission':['您确认批量删除任务？','Confirm to delete all selected tasks?'],
    'workday':['人天','Labor Day'],
    'hour':['小时','Hour'],
    'editTask':['编辑任务','Edit task'],

    //Bug     '':['',''],
    'all':['全部','All'],
    'unfinished':['未完成','Unsolved'],
    'toBeVerified':['待验证','QA confirming'],
    'toQAVerified':['待QA验收','QA verifying'],
    'closed':['已关闭','Closed'],
    'favorite':['星标收藏','Favorite'],
    'enterBugIdTitle':['请输入BugID/标题','Please input bug ID/title'],
    'discoveryDate':['发现日期','Report date'],
    'fixedDate':['修复日期','Fixed date'],
    'expectedStartDate':['期望开始日期','Expected start date'],
    'expectedFinishDate':['期望完成日期','Expected finish date'],
    'expectedDeadlineDate':['期望截止日期','Expected deadline date'],
    'sinceFrom':['日期-起','Start date'],
    'dateTo':['日期-止','End date'],
    'moreFilter':['更多筛选','More filter'],
    'level1Module':['一级模块','Level 1 module'],
    'level2Module':['二级模块','Level 2 module'],
    'createBug':['新建Bug','Create a new bug'],
    'close':['关闭','Close'],
    'discoveryFixDate':['发现/修复日期','Report/Fixed date'],
    'expectedDate':['期望日期','Expected date'],
    'discovery':['发现','Report'],
    'fix':['修复','Fixed'],
    'approved':['通过','Approved'],
    'rejected':['驳回','Rejected'],
    'verificationAgain':['重新验证','Verification again'],
    'verificationPass':['验证通过','Verification Pass'],
    'startFix':['开始修复','Start fixing'],
    'fixComplete':['修复完成','fixed'],
    'transferTo':['转发','Transfer to'],
    'bugDescription':['Bug描述','Description'],
    'bugTitle':['Bug标题','Bug title'],
    'enterBugTitle':['请输入Bug标题','Please input bug title'],
    'bugDetailDescription':['详细描述','Description'],
    'enterBugDescription':['请详细填写Bug描述','Please describe the bug in detail'],
    'addBugInfo':['等级/模块/测试消息','Level/Module/Test info'],
    'bugLevel':['Bug等级','Bug level'],
    'testInfo':['测试信息','Test info'],
    'testEnvironment':['请填写测试环境','Please input test environment'],
    'testVersion':['请填写测试版本','Please input application version'],
    'stepResult':['步骤与结果','Steps and Results'],
    'repeatSteps':['重现步骤','RPT steps'],
    'repeatStepsInfo':['请输入重现步骤，建议用1、2、3…区分',
		'Please input the repeat steps, ex. 1,2,3 …'],
    'expectResults':['期望结果','Expected results'],
    'enterExpectResults':['请输入期望结果','Please input expected results'],
    'actualResults':['实际结果','Actual results'],
    'enterActualResults':['请输入实际结果','Please input the actual results'],
    'expectedTimeOwner':['期望时间与负责人','Expected time and Owner'],
    'to':['至','To'],
    'submitBug':['提交Bug','Submit bug'],
    'actualFixedTime':['实际修复时间','Actual fixed time'],
    'bugDetailInfo':['重现步骤/实际结果/期望结果','Repeat steps/Actual results/Expected results'],
    'reply':['回复','Reply'],
    'enterReply':['请输入您的回复......','Please input your reply'],
    'send':['发送','Send'],
    'replyTo':['回复TA','Reply to'],
    'timeNode':['时间节点','Time node'],
    'addBug':['添加Bug','Add bug'],
    'qaVerify':['QA验收','QA to verify'],
    'clientVerify':['客户验收','Client to verify'],
    'operationLog':['操作记录','Operation log'],
    'newBug':['新增bug','New bugs'],
    'changeBugState':['将bug从待修复改成修复中',
		'Change the bug status from pending fix to fixing'],
    'fixBug':['修复bug','Fixed bug'],
    'verifyPass':['验收bug通过','Bug verify passed'],
    'transferBug':['将bug转发给','Transfer bug to '],
    'verifyFailed':['验收bug未通过','Verify bug failed'],
    'bugStateChange':['bug从待验证改为待修复',
		'Change the bug status from pending verifiction to pending fix.'],
    'notRepeat':['验证bug未复现','Bug can not be repeat'],
    'selectBugLevel':['请选择Bug等级','Select bug level'],
    // 'setBugWaitFix':['BUG设置为待修复','Change the bug status to pending fix'],
    // 'setBugWaitApprove':['BUG设置为待验证','Change the bug status to pending verifiction'],
    // 'setBugFixing':['BUG设置为修复中','Change the bug status to fixing'],
    // 'setBugFixed':['BUG完成修复','Change the bug status to fixed'],
    // 'setBugPass':['BUG验证通过','Bug verification passed'],
    // 'setBugReject':['BUG验证不通过','Bug verification failed'],
    // 'setBugClosed':['BUG设置为已关闭','Change the bug status to closed'],
    'confirmBatchCloseBug':['您确认批量关闭BUG？','Confirm to close all selected bugs?'],
    'confirmCloseBug':['您确认关闭BUG？','Confirm to close bug?'],
    'youConfirmBug':['您确认BUG','Are you sure bug'],

    'setWaitFix':['设置为待修复','Set to be fixed'],
    'setWaitApprove':['设置为待验证','Set to confirming'],
    'setFixing':['设置为修复中','Set to fixing'],
    'setFixed':['完成修复','Fixed'],
    'setPass':['验证通过','Verification pass'],
    'setReject':['验证不通过','Verification fail'],
    'setClosed':['设置为已关闭','Set to closed'],
    'expectTimeAndOwner':['期望日期与负责人','Expected time and Owner'],

    'unSelectModuleLevelOne':['未选择一级模块', 'Unselect level 1 module'],
    'unSelectModuleLevelTwo':['未选择二级模块', 'Unselect level 2 module'],
    'notFilledInTestEnvironment':['未填写测试环境', 'Not filled in test environment'],
    'notFilledInTestVersion':['未填写测试版本', 'Not filled in test version'],

    //测试用例
    'executed':['已执行','Executed'],
    'executing':['执行中','Executing'],
    'batchStartTestCase':['批量开始执行测试用例', 'Batch execute test case'],
    'batchFinishTestCase':['批量结束执行测试用例', 'Batch end executing test case'],
    'batchRestartTestCase':['批量重新执行测试用例', 'Batch execute test case again'],
    'batchStartTestCaseAlert':['批量开始执行测试用例', 'Start executing test cases in batch'],
    'batchFinishTestCaseAlert':['批量结束执行测试用例', 'Batch end test case execution'],
    'batchRestartTestCaseAlert':['批量重新执行测试用例', 'Re-execute the test cases in batch'],
    'makeSureBatchStartTestCaseAlert':['是否批量开始执行测试用例', 'Whether to start executing test cases in batches'],
    'makeSureBatchFinishTestCaseAlert':['是否批量结束执行测试用例', 'Whether to batch end the execution of test cases'],
    'makeSureBatchRestartTestCaseAlert':['是否批量重新执行测试用例', 'Whether to re-execute the test cases in batch'],
    'testCasesSumary':['用例统计','Test case summary'],
    'allTestCases':['全部用例','All test cases'],
    'addTestCases':['新建用例','Create test case'],
    'createTestCases':['创建测试用例','Create test case'],
    'enterTestCaseTitle':['请输入测试用例标题','Please input test case title'],
    'enterTestCaseTitleOrId':['请输入测试用例ID/标题','Please input case ID/title'],
    'testSteps':['测试步骤','Test steps'],
    'enterContent':['请输入内容','Please input the content'],
    'expectedResults':['预期结果','Expected results'],
    'enterExpectedResults':['请输入预期结果','Please input expected results'],
    'save':['保存','Save'],
    'latestResults':['最新结果','Latest result'],
    'notPass':['不通过','Failed'],
    'testTimes':['测试次数','Test times'],
    'passTimes':['通过次数','Pass times'],
    'passRate':['通过率','Pass rate'],
    'execute':['执行','Execute'],
    'fail':['失败','Failed'],
    'executeAgain':['再次执行','Execute again'],
    'associationBug':['关联BUG','Association bug'],
    'enterBugId':['点击创建，输入BUG ID（回车保存）',
		'Input the bug ID and press enter key to save.'],
    'createButton':['点击创建','Click the create button'],
    'createNewBug':['创建新BUG','New bug'],
    'unassociated':['不关联','Unassociated'],
    'testCase':['测试用例','Test case'],
    'testCaseStep':['用例步骤','Test cases step'],
    'testLog':['测试记录','Test case log'],
    'executer':['执行者','Tester'],
    'executeTime':['执行时间','Execute datetime'],
    'result':['结果','Result'],
    'testCaseResult':['记录测试结果','Test Result'],
    'executeFrequency':['执行第*次测试用例','* time to execute test cases'],
    'executeFail':['标记第*次测试用例结果为失败','Mark the * time execute test cases was failed'],
    'executePass':['标记第*次测试用例结果为通过','Mark the * time execute test cases was passed'],
    'addTestCase':['添加测试用例','Add test case'],
    'editTestCase':['编辑测试用例','Edit test case'],
    'deleteTestCase':['删除测试用例','Delete test case'],
    'makeSureDeleteTestCase':['您确认删除测试用例？','Ensure to delete test case?'],
    'updateAlert':['系统正在为您上传数据，请稍后...','Uploading, please wait...'],
    'analysisAlert':['系统正在为您解析数据，请稍后...','Data analysing please wait...'],

    //成员
    'member':['成员','Member'],
    'people':['人','Members'],
    'searchMemberName':['搜索成员姓名','Search by member name'],
    'developer':['开发','Developer'],
    'projectManager':['项目经理','Project Manager'],
    'qa':['测试','QA'],
    'client':['客户','Client'],
    'email':['邮箱','Email'],
    'lastLoginTime':['最近登录时间','Last login time'],
    'addProjectTime':['加入项目时间','Join time'],
    'removeMember':['移除成员','Remove'],
    'confirmRemoveMember':['确定移除成员','Confirm to remove members'],
    'editMember':['编辑成员信息','Edit member info'],
    'name':['姓名','Name'],
    'role':['角色','Role'],
    'visible':['可见其他成员联系方式','See contact info of other members'],
    'updateRole':['仅支持修改成员的角色和权限','Only member roles and permissions are editable'],
    'taskStatistics':['任务统计','Task summary'],
    'bugStatistics':['Bug统计','Bug statistics'],
    'waitClient':['待客户验收','Client verifying'],
    'inviteMember':['邀请新成员','Invite new members'],
    'projectMembers':['项目成员','Project members'],
    'cooperation':['从合作过的成员中导入','Import from a member that has worked with'],
    'enterEmail':['请输入邮箱','Please input email'],
    'sendInvite':['发送邀请','Send out invitation'],
    'lastCooperation':['最近合作过的成员','Members who have worked together'],
    'emailAddress':['邮箱地址','Email address'],
    'backOk':['返回确定','Confirm and return'],
    'headImageIsUploading':['头像正在上传中请稍候','Uploading profile picture, please wait…'],
    'emailIsSending':['邮件发送中，请稍候……','Sending email, please wait…'],
    'cantRemoveMyselfFromProject':['不能将自己移出项目','You cannot remove yourself from project'],
    'inviteAlreadyExist':['邀请成员中存在已经被邀请的成员','Members in invite list have already existed in project'],
    'duplicate':['重复','Members in invite list have already existed in project'],
    'noAllocateRole':['没有分配角色','Not allocate role'],
    'selectMember':['请选择需要邀请的成员','Please select member to invite'],
    'dailyNotice':['通知','Notice'],
    'dailyNoticeTip':['每日邮件通知开关','Daily email notice switch'],
    'modifyHeadPortrait':['修改头像','Modify head portrait'],
    'selectImage':['选择图片','Select image'],
    'mailNoticeIsOn':['是否接收每日邮件','Whether to receive daily mail'],
    'seeOtherMemberContact':['其他成员联系方式','Other member contact way'],
    'cannotSee':['不可见','Not visible'],
    'canSee':['可见','Visible'],
    'cannotReceive':['不接收','Not receive'],
    'canReceive':['接收','Receive'],

    //模块
    'module':['模块','Module'],
    'moduleManagement':['模块管理','Module management'],
    'enterModuleName':['请输入模块名称','Please input module name'],
    'mainOwner':['主负责人','Owner'],
    'choose':['请选择','Choose'],
    'createModule':['创建模块','Create module'],
    'sn':['序号','SN'],
    'level1Name':['一级模块名称','Level 1 module name'],
    'viewLevel2':['查看二级模块','View level 2 module'],
    'createLevel1':['创建一级模块','Create level 1 module'],
    'moduleName':['模块名称','Name'],
    'enterSort':['请输入排序','Please input order No.'],
    'chooseMainOwner':['请选择主负责人','Please choose the responsible person'],
    'on':['确认','Confirm'],
    'editLevel1':['编辑一级模块','Edit level 1 module'],
    'level2Name':['二级模块名称','Level 2 module name'],
    'createLevel2':['创建二级模块','Create level 2 module'],
    'upperModule':['上级模块','Level One'],
    'editLevel2':['编辑二级模块','Edit level 2 module'],
    'deleteLevel1':['删除一级模块','Delete the main module'],
    'deleteLevel1Tip':['您确认批量删除一级模块？','Confirm to delete all selected main modules?'],
    'deleteLevel2':['删除二级模块','Delete the secondary module'],
    'deleteLevel2Tip':['您确认批量删除二级模块？','Confirm to delete all selected secondary modules?'],

    //设置
    'projectSet':['项目设置','Project setting'],
    'saveUpdate':['保存修改','Save your modify'],
    'mailNotice':['每日邮件通知','Daily mail notification'],
    'noticeInfo':['系统将发送每日邮件至项目内成员的邮箱。包括每日任务统计，项目统计等',
		'System will send daily mail to members mailbox. Including daily task statistics, project statistics, etc'],
    'notNoticeInfo':['系统将不发送每日邮件至项目内成员的邮箱。包括每日任务统计，项目统计等',
		'System will not send project daily report to member mailbox. Include daily task and daily project, etc'],
    'closeProject':['归档项目','Archive the project'],
    'closeProjectInfo':['归档项目后，该项目的状态将变成历史项目，项目任何信息不可再编辑。团队管理员可在「项目设置」中重新打开项目，恢复项目状态及成员对项目操作权限。',
		'Archive projects are read-only and no information about the project can be edited. The team administrator can re-open the project in Project Settings, restore the project status and the operation rights of members on the project.'],
    'closeProjectInfoPart1':['归档项目后，该项目的状态将变成历史项目，项目任何信息不可再编辑。',
        'Archive projects are read-only and no information about the project can be edited.'],
    'closeProjectInfoPart2':['团队管理员可在「项目设置」中重新打开项目，恢复项目状态及成员对项目操作权限。',
        'The team administrator can re-open the project in Project Settings, restore the project status and the operation rights of members on the project.'],
    'confirmClose':['我已了解，确认归档','I have understood. Confirm archive the project'],
    'openProject':['激活项目','Activate the project'],
    'confirmOpenProject':['您确认激活项目？','Do you confirm activation of the project?'],
    'openProjectInfo':['激活项目后，该项目的状态将变成进行中，系统将恢复成员对项目操作能力。',
		'Activate the project and release the user\'s ability to manipulate the project'],
    'confirmOpen':['我已了解，激活项目','I have understood. Confirm activate the project.'],
    'deleteProject':['删除项目','Delete the project'],
    'confirmDeleteProject':['您确认删除项目？','Are you sure to delete the item?'],
    'deleteProjectInfo1':['删除项目会删除项目内的所有数据(包括任务、BUG、测试用例、成员等数据)。',
		'All data in project including missions,bugs,test cases,members info will be deleted while deleting the project'],
    'deleteProjectInfo2':['删除操作无法恢复！请谨慎操作！',
        'The delete operation could not be restored.Please operate carefully'],
    'deleteProjectInfo3':['项目若存有重要数据，建议您归档项目。',
        'Archive the project if there is important data.'],
    'confirmDelete':['我已了解，确认删除','Confirm and delete'],
    'confirmCloseProject':['您确认归档项目？','Do you confirm the archiving project?'],
    'projectCover':['项目封面','Project cover image'],
    'notInProject':['您不是当前项目的成员，请重新选择项目','You are not join in this project. Please select another.'],

    //基本资料
    'personalInfo':['个人资料','Profile'],
    'enterName':['请输入用户名','Please input the user name'],
    'companyInfo':['公司资料','Company info'],
    'companyName':['公司名称','Company name'],
    'enterCompanyName':['请输入公司名称','Please input company name'],
    'address':['地址','Address'],
    'enterCompanyAddress':['请输入公司地址','Please input company address'],
    'businessLicenseNo':['营业执照号','BLN'],
    'creditCode':['营业执照注册号或组织机构代码或统一社会信用代码','BLN/OC/USCC'],
    'businessLicenseImage':['营业执照照片','License'],
    'uploadInfo2':['只能上传jpg/png文件，且不超过1M','Only JPG/PNG files can be uploaded, and no more than 1M'],
    'contacter':['联系人','Contacter'],
    'enterContacterName':['请输入联系人姓名','Please input contacter name'],
    'contactPhone':['联系电话','Telephone'],
    'enterContactPhone':['请输入联系电话','Please input telephone No.'],
    'uploadBusinessLicenseImage':['请上传营业执照照片','Please upload the license'],
    'uploadHeadImage':['上传头像','Upload photo as avatar'],

    //账号设置
    'unbound':['未绑定','Unbound'],
    'bound':['已绑定','Binded'],
    'emailBoundInfo':['通过邮箱登录、邮件通知提醒、其他需要使用邮箱验证的功能',
		'The purpose of mail address in this system: login,notification,authentication'],
    'modify':['修改','Modify'],
    'modifyEmail':['修改邮箱','Modify email address'],
    'newEmail':['新邮箱','New email'],
    'enterNewEmail':['请输入新邮箱地址','Please input new email address'],
    'enterNewEmailCode':['请输入新邮箱验证码','Please input new email code'],
    'modifyEmailInfo':['邮箱作为登录账号，请谨慎修改','Email address is the login account, Please change carefully'],
    'unboundPhoneInfo':['您还没有设置绑定手机','You have not bind the telephone No.'],
    'boundPhoneInfo':['绑定手机号用于项目组内成员相互联系、接收短信通知、其他需要使用手机号的功能',
		'The purpose of telephone No. in this system: contact with members in the project,receive notifications'],
    'boundPhone':['绑定手机','Bind Phone No.'],
    'modifyPhone':['修改手机号','Change Phone No.'],
    'newPhone':['新手机号','New Phone No.'],
    'enterNewPhone':['请输入新手机号','Please input new Phone No.'],
    'password':['密码','Password'],
    'passwordInfo':['建议使用字母、数字与标点的组合，可大幅提升账号安全',
		'It is recommended to use a combination of letters, Numbers and punctuation to greatly improve account security'],
    'modifyPassword':['修改密码','Modify password'],
    'newPassword':['新密码','New PWD'],
    'enterNewPassword':['请输入新密码','Please input new password'],
    'confirmPassword':['确认密码','Confirm PWD'],
    'enterNewPasswordAgain':['请再次输入新密码','Please input the new password again'],
    'twoPasswordNotSame':['两次输入的密码不一样','ERROR:Your new password and confirmed new password do not match.'],
    'noBandEmail':['您还没有绑定邮箱','You have not yet bound the mailbox'],
    'noBandPhone':['您还没有绑定手机','You have not yet bound the phone'],

    //与我相关
    'task':['任务','Task'],
    'enterTaskId':['请输入任务ID/标题','Please input the task ID/title'],
    'state':['状态','State'],
    'participants':['参与者','Participant'],
    'newTask':['分配给你新任务','Assigning a new task to you'],
    'changeTaskState':['将任务状态改为进行中','Change the task status to ongoing'],
    'finishTask':['完成了任务','Task is accomplished'],
    'chooseBugState':['请选择Bug状态','Please select bug status'],
    'chooseMissionState':['请选择任务状态','Please select mission status'],
    'editBug':['编辑bug','Edit bug'],
    'delBug':['删除bug','Delete bug'],
    'forwardBug':['将bug转发给','Transfer bug to'],
    'assigningNewBug':['分配给你新bug','Assigning a new bug to you'],
    'forwardBugToYou':['将bug转发给你','Transfer bug to you'],
    'aboutMe':['与我相关','About Me'],
    'projectIWorked':['我参与的项目','Project I worked on'],
    'projectIManaged':['我管理的项目','Project I managed'],

    //我的套餐
    'myNowPackage':['当前套餐','Package'],
    'invalid':['到期','Invalid'],
    'myPackageInvalidTime':['到期时间','Invalid time'],
    'myPackageInvalidDate':['到期日期','Invalid date'],
    'myPackageBuy':['开通套餐','Buy'],
    'myPackageChange':['更换套餐','Change'],

    //创建新项目
    'setProjectName':['设置项目名称','Set project name'],
    'inviteProjectMember':['邀请项目成员','Invite project member'],
    'enterProjectName':['请输入项目名称','Please input project name'],
    'projectMember':['项目成员','Project member'],
    'next':['下一步','Next'],
    'previous':['上一步','Previous'],
    'confirmCreateProject':['确认创建项目','Confirm to create project'],
    'importMemberFromProject':['从合作过的成员中导入','Import from a member that has worked with'],
    'importMember':['导入成员','Import members'],
    'choosed':['已选择','Choosed'],
    'back':['返回','Back'],
    'createProjectAlert':['系统正在为您创建项目，请稍候...','Please wait while the system creates the project for you…'],

    //Excel
    'importExcelMessage':['请选择需要导入的Excel文件','Select the Excel file you want to import'],
    'importExcelMessageLoading':['系统正在为您导入数据，请稍候','Please wait while the system is importing the data for you…'],
    'exportExcelMessage':['系统正在为您导出数据，请稍候...','Please wait while the system is exporting the data for you…'],

    //反馈记录
    'feedbackLog':['反馈记录','Feedback Log'],
    'feedbackPersonInfo':['反馈人信息','Feedback person info'],
    'feedbacksearch':['搜索反馈内容/联系方式','feedback content/contact way'],
    'feedbackType':['反馈类型','Type'],
    'feedbackTypeSelect':['请选择反馈类型','select feedback type'],
    'feedbackAdvice':['改进建议','Improve advice'],
    'feedbackProblem':['使用问题','Problem in use'],
    'feedbackState':['处理状态','Handle state'],
    'feedbackStateSelect':['请选择处理状态','select handle state'],
    'waitHandle':['未处理','Wait handle'],
    'haveHandled':['已处理','Have handled'],
    'feedbackContent':['反馈内容','Content'],
    'contactWay':['联系方式','Contact'],
    'submitTime':['提交时间','Submit time'],
    'setHaveHandled':['标记为已处理','Mark feedback handled'],
    'makeSureSetHaveHandled':['您确定标记为已处理吗？','Do you confirm to mark feedback handled?'],
    'feedbackBtnInfo':['建议与问题反馈','Feedback'],
    'feedBackInputRemindOne':['请输入您在使用过程中的建议或问题',
    'Please enter your improve advice or problem in use'],
    'feedBackInputRemindTwo':['请留下联系方式（手机号）',
    'Please enter your contact way (phone number)'],
    'feedBackSuccessInfo':['感谢您的反馈！您的建议将成为我们改进产品提升服务的重要依据，欢迎您继续关注和支持我们。',
    'Thanks for your feedback! Your suggestions will become an important basis for us to improve our product upgrade services. You are welcome to continue to pay attention and support us.'],

    //套餐
    'package':['套餐','Package'],
    'packageAdd':['新增套餐','Package add'],
    'packageUpdate':['编辑套餐','Update'],
    'packageDelete':['删除','Delete'],
    'packageSearch':['请输入套餐名称','Please enter package name'],
    'deletePackageTip':['您确定要删除该套餐吗？','Confirm to delete this package?'],
    'packageDel':['套餐',' package'],
    'packageName':['套餐名称','Name'],
    'packageSort':['排序','Sort'],
    'packageDuration':['套餐时长','Duration'],
    'packageFee':['费用','Fee'],
    'packageContent':['套餐内容','Content'],
    'packageUserQuantity':['使用人数','User quantity'],
    'packageCreateTime':['创建时间','Create time'],
    'packageUpdateTime':['更新时间','Update time'],
    'packageMemberCount':['成员数量','Member'],
    'packageProjectCount':['项目数量','Project'],
    'packageBugCount':['Bug数量','Bug'],
    'packageMissionCount':['任务数量','Mission'],
    'packageTestCaseCount':['测试用例','Test case'],
    'packageEmailCount':['邮件通知','Email'],
    'packageStorageSpace':['存储空间','Storage'],
    'packageUnlimited':['无限','Unlimited'],
    'packageFeeType':['美元','$'],
    'packageDay':['天','Day'],
    'packageDays':['天','Days'],
    'packageMonth':['个月','Month'],
    'packageMonths':['个月','Months'],
    'packageYear':['年','Year'],
    'packageYears':['年','Years'],
    'packageMember':['人','Member'],
    'packageMembers':['人','Members'],
    'packageProject':['个','Project'],
    'packageProjects':['个','Projects'],
    'packageBug':['个','Bug'],
    'packageBugs':['个','Bugs'],
    'packageTask':['个','Task'],
    'packageTasks':['个','Tasks'],
    'packageTestCase':['个','Test Case'],
    'packageTestCases':['个','Test Cases'],
    'packageEmailNotification':['个','Email Notification'],
    'packageEmailNotifications':['个','Email Notifications'],

    'enterPackageName':['请输入套餐名称','Please input package name'],
    'enterPackageFee':['请输入价格','Please input package fee'],
    'enterPackageDuration':['请输入套餐时长','Please input package duration'],
    'enterPackageSort':['请输入排序序号，至多两位小数','Please input positive number.At most 2 decimal places'],
    'enterPackageMemberCount':['请输入成员数量','Please input member quantity'],
    'enterPackageProjectCount':['请输入项目数量','Please input project quantity'],
    'enterPackageBugCount':['请输入Bug数量','Please input bug quantity'],
    'enterPackageMissionCount':['请输入任务数量','Please input mission quantity'],
    'enterPackageTestCaseCount':['请输入测试用例数量','Please input test case quantity'],
    'enterPackageEmailCount':['请输入邮件通知数量','Please input email notification quantity'],
    'enterPackageStorageSpace':['请输入存储空间','Please input storage space'],

    //套餐订单
    'productOrder':['订单列表','Package order'],
    'productOrderNumber':['订单号','Order number'],
    'productOrderState':['订单状态','Order state'],
    'productOrderBuyer':['用户','Buyer'],
    'productOrderDuration':['时长','Duration'],
    'productOrderUnitPrice':['单价','Unit price'],
    'productOrderRejectReason':['驳回原因','Reject reason'],
    'productOrderPayMoney':['支付金额','Pay money'],
    'product':['套餐','Package'],
    'customizedProduct':['定制套餐','Customize package'],
    'changeProduct':['更换套餐','Change package'],
    'createTime':['下单时间','Create time'],
    'checkTime':['核实时间','Check time'],
    'waitCheck':['待核实','Wait check'],
    'checkPass':['核实通过','Pass'],
    'checkReject':['核实未通过','Reject'],
    'productOrderBuyerInfo':['用户信息','Buyer information'],
    'productOrderBuyerName':['用户名','Name'],
    'productOrderBuyerPhoneNumber':['手机号','Phone'],
    'productOrderBuyerEmail':['邮箱','Email'],
    'productOrderBuyerCompany':['公司','Company'],
    'selectProduct':['请选择套餐','Select package'],
    'productInfo':['套餐信息','Package information'],
    'paymentInstrument':['支付凭证','Payment instrument'],
    'payMoney':['实际支付','Pay money'],
    'dollar':['美元','Dollar'],
    'productOrderValidTimeMax':['到期时间','Invalid time'],
    'productOrderPayType':['支付方式','Pay type'],
    'productOrderPayUnderLine':['线下转账','Pay underline'],
    'productOrderRemark':['备注','Remark'],
    'packageUseInfo':['套餐使用量统计','Package use info'],
    'packageOrderList':['套餐充值记录','Package order'],
    'packageNoPay':['未购买','No pay'],
    'selectProductOrderDate':['请选择日期','Select date'],
    'selectProductOrderState':['请选择订单状态','Select order state'],
    'enterProductOrderKeyword':['请输入订单号/用户名','Order number / buyer'],
    'enterProductOrderRejectReason':['请输入驳回原因','Please input reject reason'],
    'enterProductOrderPayMoney':['请输入实际支付金额','Please input pay money'],
    'productNoBuy':['您所在项目的创建者未购买套餐','Project creator does not buy package'],
    'productIsInValid':['套餐已失效','Package is invalid'],
    'productStorageSpaceExceedLimit':['存储空间用量超过套餐限制','Storage space exceed the package limit'],

    //项目列表
    'projectStick':['置顶','Stick on top'],
    'projectUnStick':['取消置顶','Remove sticky'],

    //系统后台 成员列表
    'memberList':['用户列表','Member'],
    'memberManage':['用户管理','Member'],
    'memberInfo':['用户信息','MemberInfo'],
    'whiteList':['白名单','Whitelist'],
    'blackList':['黑名单','Blacklist'],
    'memberName':['用户名','Name'],
    'enterNamePhoneNumEmailCompany':['请输入用户名/手机号/邮箱/所属公司',
		'Please input user name/Phone No./email/company'],
    'belongCompany':['所属公司','Company'],
    'belongCompanyInfo':['所属公司信息','Company information'],
    'recentLoginTime':['最近一次登录','Last login time'],
    'registerTime':['注册时间','Regist time'],
    'remark':['备注','Remark'],
    'enterRemark':['请输入备注','Please input remarks'],
    'bannedReason':['拉黑原因','Blocking reason'],
    'bannedTime':['拉黑时间','Blocking time'],
    'ban':['拉黑','Block'],
    'banMember':['拉黑用户','Blocking account'],
    'banMemberTipHead':['您确定要拉黑“','Confirm to block user“'],
    'banMemberTipTail':['”该用户吗？该用户将无法登录','”? This user will be unable to login again.'],
    'enterBanReason':['请输入拉黑原因','Please input the reason for blocking'],
    'removeFromBlackList':['移出黑名单','Remove'],
    'removeFromBlackListInfo':['您确认将会员移出黑名单','Confirm to remove the member from the blacklist'],
    'clickAndWatch':['点击查看','Click to view'],
    'editInfo':['编辑信息','Edit information'],
    'socialCreditAndOther':['营业执照号/组织机构代码/统一社会信用代码',
		'BLN/OC/USCC'],
    'watchBigImage':['查看大图','Larger version'],

    'notOpen':['未开启','Not open'],
    'open':['开启','Opening'],
    'emailNotification':['每日邮件通知','Daily email'],
    'productUsing':['当前使用套餐','Package using'],
    'invalidTime':['到期时间','Invalid time'],

    //系统后台 任务列表
    'missionRecord':['任务记录','Task Record'],
    'missionManage':['任务管理','Task'],
    'mission':['任务','Task'],
    'enterMissionIdTitle':['任务ID/标题','Task ID/title'],
    'chooseProject':['请选择项目','Please select project'],
    'belongProject':['所属项目','Project'],
    'isDelay':['是否逾期','Overdue'],
    'missionId':['任务ID','Task ID'],
    'yes':['是','Yes'],
    'no':['否','No'],

    //系统后台 模块列表
    'projectModule':['项目模块','Project module'],
    'projectModuleManage':['项目模块管理','Project module'],
    'enterModuleLevelOneName':['请输入一级模块名称','Please input level 1 module name'],
    'enterModuleLevelTwoName':['请输入二级模块名称/主负责人','Please input level 2 module name/main responsible person'],

    //系统后台 项目
    'projectManage':['项目管理','Project'],
    'notNotice':['已归档', 'Archived'],
    'projectNameManagerPhrases':['请输入项目名称/管理员备注/归属人', 'Please input project name/remarks/belonger '],
    'ownerShip':['归属人', 'Belonger'],
    'company':['公司', 'Company'],
    'testCaseTotalCounts':['测试用例总数','Test case count'],
    'createTime':['创建时间','Create time'],
    'detail':['详情','Detail'],
    'addRemark':['添加备注','Add remark'],
    'editRemark':['编辑备注','Edit remark'],

    //系统后台 测试用例
    'testCaseStatistics':['测试用例统计','Test case summary'],
    'testCaseId':['测试用例ID','Test case ID'],
    'testCaseRecord':['测试用例记录','Test case log'],
    'testCaseManage':['测试用例管理','Test case'],
    'executeResult':['执行结果','Execution result'],

    //系统后台 BUG
    'bugRecord':['Bug记录','Bug log'],
    'bugManage':['Bug管理','Bug'],
    'allBug':['所有Bug','All Bugs'],
    'bugIdOrTitle':['BugID/标题','BugID/title'],

    //系统后台 操作记录
    'operateRecord':['用户操作记录','Member Operation'],
    'enterOperateTypeContent':['请输入操作类型/内容','Operation Type/Content'],
    'operatePerson':['操作人','Member'],
    'chooseOperatePerson':['请选择操作人','Select Member'],
    'project':['项目','Project'],
    'operateType':['操作类型','Operation Type'],
    'operateContent':['操作内容','Operation Content'],
    'operateTime':['操作时间','Operate Datetime'],
    "systemServeRecord":['系统管理员操作记录','Admin Operation'],

    //系统后台 系统管理员
    'systemAdmin':['系统管理员','System Admin'],
    'enterNameOrEmail':['请输入用户名/邮箱','Please input member name or email'],
    'addAdmin':['新建管理员','Create new system admin'],
    'resetPwd':['重置密码','Reset Password'],
    'enterNameOrAccount':['请输入用户名（登录账号）','Please input user name(login account)'],
    'loginPwd':['登录密码','Password'],
    'enterLoginPwd':['请输入登录密码','Please input login password'],
    'admin':['管理员','Administrator'],
    'deleteAdminTipHead':['您确定要删除该管理员吗？','Confirm to delete admin account?'],
    'set':['设置','Setting'],
    'adminNameSetTipText':['用户名作为登录账号，请谨慎修改','Please modify carefully, user name is login account'],
    'safeSet':['安全设置','Security setting'],
    'adminEmailSetTipText':['通过邮箱登录、邮件通知提醒、其他需要使用邮箱验证的功能',
		'Email login, email notification and reminder, and other functions that require email verification'],
    'bind':['绑定','Bind'],
    'bindEmail':['绑定邮箱','Bind Email'],
    'adminPwdSetTipText':['建议使用字母、数字与标点的组合，可大幅提升账号安全',
		'It is recommended to use a combination of letters, Numbers and punctuation to greatly improve account security'],
    'tailorHeadPortrait':['裁剪头像','Profile cutting'],
    'changePicture':['更换图片','Replace the picture'],
    'changePictureTipText':['上传2M以内，JPG或PNG图片','Upload within 2M, JPG or PNG pictures']
}
